import { applyMiddleware, compose, createStore } from 'redux';
import { logger } from 'redux-logger';
import thunk from 'redux-thunk';
import reducers from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension';
import { getFirebase } from 'react-redux-firebase';

export const middleware =
  process.env.NODE_ENV === 'production'
    ? compose(applyMiddleware(thunk.withExtraArgument({ getFirebase })))
    : composeWithDevTools(
        compose(
          applyMiddleware(thunk.withExtraArgument({ getFirebase }), logger)
        )
      );

export default createStore(reducers, middleware);
